"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.TextField = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _CoreInput = require("../internal/WixUiCoreComponents/components/CoreInput");
var _TextFieldSt = require("./TextField.st.css");
var _onStage = require("@wix/wix-ui-icons-common/on-stage");
var _system = require("@wix/wix-ui-icons-common/on-stage/system");
var _IconButton = require("../IconButton");
var _types = require("../Tooltip/types");
var _dataKeys = require("./dataKeys");
var _IconTooltip = require("../IconTooltip");
var _ErrorMessageWrapper = require("../internal/ErrorMessageWrapper");
var _types2 = require("./types");
var _a11y = require("../../common/a11y");
var _uniqueId = _interopRequireDefault(require("../../common/uniqueId"));
var _jsxFileName = "/home/builduser/work/31dad9578a4e06bb/packages/wix-ui-tpa/dist/cjs/components/TextField/TextField.tsx";
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
class TextField extends React.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "_rootRef", /*#__PURE__*/React.createRef());
    (0, _defineProperty2.default)(this, "_inputId", void 0);
    (0, _defineProperty2.default)(this, "_errorMessageId", void 0);
    (0, _defineProperty2.default)(this, "_prefixLabelId", void 0);
    (0, _defineProperty2.default)(this, "inputRef", void 0);
    (0, _defineProperty2.default)(this, "state", {
      isErrorTooltipShown: false
    });
    (0, _defineProperty2.default)(this, "TextFieldRef", /*#__PURE__*/React.createRef());
    (0, _defineProperty2.default)(this, "focus", () => {
      this.TextFieldRef.current.focus();
    });
    (0, _defineProperty2.default)(this, "blur", () => {
      this.TextFieldRef.current.blur();
    });
    (0, _defineProperty2.default)(this, "showErrorTooltip", () => {
      this._toggleTooltip(true);
    });
    (0, _defineProperty2.default)(this, "hideErrorTooltip", () => {
      this._toggleTooltip(false);
    });
    (0, _defineProperty2.default)(this, "_getClearButton", shouldAddClearButtonGap => {
      const {
        clearButtonAriaLabel,
        clearButtonAriaLabelledby,
        onClear
      } = this.props;
      return /*#__PURE__*/React.createElement("div", {
        className: _TextFieldSt.classes.clearButtonWrapper,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 77,
          columnNumber: 7
        }
      }, /*#__PURE__*/React.createElement(_IconButton.IconButton, {
        className: _TextFieldSt.classes.clearButton,
        "data-hook": _dataKeys.DATA_HOOKS.CLEAR_BUTTON,
        "aria-label": clearButtonAriaLabel,
        "aria-labelledby": clearButtonAriaLabelledby,
        skin: _IconButton.IconButtonSkins.Line,
        onClick: onClear ? () => this.props.onClear() : undefined,
        icon: /*#__PURE__*/React.createElement(_system.ClearXSmall, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 85,
            columnNumber: 17
          }
        }),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 78,
          columnNumber: 9
        }
      }), shouldAddClearButtonGap && /*#__PURE__*/React.createElement("div", {
        className: _TextFieldSt.classes.clearButtonGap,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 87,
          columnNumber: 37
        }
      }));
    });
    (0, _defineProperty2.default)(this, "_getErrorSuffix", () => {
      const {
        isErrorTooltipShown
      } = this.state;
      const {
        errorMessage,
        errorTooltipPlacement,
        errorTooltipMaxWidth
      } = this.props;
      return /*#__PURE__*/React.createElement(_IconTooltip.IconTooltip, {
        "data-hook": _dataKeys.DATA_HOOKS.ERROR_ICON,
        message: errorMessage,
        icon: /*#__PURE__*/React.createElement(_onStage.Error, {
          className: _TextFieldSt.classes.errorIcon,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 101,
            columnNumber: 15
          }
        }),
        tooltipId: this._errorMessageId,
        tooltipSkin: _types.TooltipSkin.Error,
        showTooltip: isErrorTooltipShown,
        onClick: this._onErrorButtonClick,
        onClickOutside: this._onClickOutside,
        tooltipProps: {
          placement: errorTooltipPlacement,
          moveBy: {
            x: 5,
            y: 0
          },
          maxWidth: errorTooltipMaxWidth
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 98,
          columnNumber: 7
        }
      });
    });
    (0, _defineProperty2.default)(this, "_getSuccessSuffix", () => {
      return /*#__PURE__*/React.createElement(_onStage.Check, {
        "data-hook": _dataKeys.DATA_HOOKS.SUCCESS_ICON,
        className: _TextFieldSt.classes.successIcon,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 118,
          columnNumber: 7
        }
      });
    });
    (0, _defineProperty2.default)(this, "_getArrowsSuffix", () => {
      const triggerInputEvent = () => {
        var _this$inputRef;
        return (_this$inputRef = this.inputRef) == null ? void 0 : _this$inputRef.dispatchEvent(new Event('input', {
          bubbles: true
        }));
      };
      const stepUp = () => {
        var _this$inputRef2;
        (_this$inputRef2 = this.inputRef) == null ? void 0 : _this$inputRef2.stepUp();
        triggerInputEvent();
      };
      const stepDown = () => {
        var _this$inputRef3;
        (_this$inputRef3 = this.inputRef) == null ? void 0 : _this$inputRef3.stepDown();
        triggerInputEvent();
      };
      return /*#__PURE__*/React.createElement("div", {
        className: _TextFieldSt.classes.arrowsSuffixWrapper,
        "data-hook": _dataKeys.DATA_HOOKS.ARROW_ICONS,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 138,
          columnNumber: 7
        }
      }, /*#__PURE__*/React.createElement("button", {
        className: _TextFieldSt.classes.arrowBtn,
        onClick: stepUp,
        type: "button",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 142,
          columnNumber: 9
        }
      }, /*#__PURE__*/React.createElement(_onStage.ChevronUpSmall, {
        size: 16,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 143,
          columnNumber: 11
        }
      })), /*#__PURE__*/React.createElement("button", {
        className: _TextFieldSt.classes.arrowBtn,
        onClick: stepDown,
        type: "button",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 145,
          columnNumber: 9
        }
      }, /*#__PURE__*/React.createElement(_onStage.ChevronDownSmall, {
        size: 16,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 146,
          columnNumber: 11
        }
      })));
    });
    (0, _defineProperty2.default)(this, "_getSuffix", () => {
      const {
        error,
        errorMessage,
        success,
        successIcon,
        suffix,
        withClearButton,
        value,
        disabled,
        newErrorMessage,
        type
      } = this.props;
      const shouldShowCustomSuffix = !!suffix;
      const shouldShowErrorIcon = error && errorMessage && !newErrorMessage;
      const shouldShowSuccessIcon = successIcon && success;
      const shouldShowClearButton = withClearButton && value && !disabled;
      const shouldShowArrows = type === 'number';
      const shouldAddClearButtonGap = shouldShowCustomSuffix || shouldShowErrorIcon || shouldShowSuccessIcon;
      const hasSuffix = shouldShowCustomSuffix || shouldShowErrorIcon || shouldShowSuccessIcon || shouldShowClearButton || shouldShowArrows;
      return hasSuffix ? /*#__PURE__*/React.createElement("div", {
        className: (0, _TextFieldSt.st)(_TextFieldSt.classes.suffixWrapper, {
          arrows: shouldShowArrows
        }),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 183,
          columnNumber: 7
        }
      }, shouldShowClearButton ? this._getClearButton(shouldAddClearButtonGap) : null, shouldShowErrorIcon ? this._getErrorSuffix() : null, shouldShowSuccessIcon ? this._getSuccessSuffix() : null, shouldShowArrows ? this._getArrowsSuffix() : null, suffix ? /*#__PURE__*/React.createElement("div", {
        className: _TextFieldSt.classes.customSuffix,
        "data-hook": _dataKeys.DATA_HOOKS.CUSTOM_SUFFIX,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 195,
          columnNumber: 11
        }
      }, suffix) : null) : null;
    });
    (0, _defineProperty2.default)(this, "_getPrefix", () => {
      const {
        prefix,
        prefixLabel
      } = this.props;
      return prefix ? /*#__PURE__*/React.createElement("span", {
        "data-hook": _dataKeys.DATA_HOOKS.PREFIX,
        className: _TextFieldSt.classes.prefix,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 210,
          columnNumber: 7
        }
      }, prefix, prefixLabel ? /*#__PURE__*/React.createElement("span", {
        id: this._prefixLabelId,
        className: _TextFieldSt.classes.prefixLabel,
        "data-sr-only": "true",
        "data-hook": _dataKeys.DATA_HOOKS.PREFIX_LABEL,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 213,
          columnNumber: 11
        }
      }, prefixLabel) : null) : null;
    });
    (0, _defineProperty2.default)(this, "_toggleTooltip", showTooltip => {
      this.setState({
        isErrorTooltipShown: showTooltip
      });
    });
    (0, _defineProperty2.default)(this, "_onErrorButtonClick", () => {
      const {
        isErrorTooltipShown
      } = this.state;
      this._toggleTooltip(!isErrorTooltipShown);
    });
    (0, _defineProperty2.default)(this, "_onClickOutside", () => {
      if (this._rootRef.current && !this._rootRef.current.contains(document.activeElement)) {
        this._toggleTooltip(false);
      }
    });
    (0, _defineProperty2.default)(this, "_onFocus", e => {
      const {
        onFocus
      } = this.props;
      if (onFocus) {
        onFocus(e);
      }
      if (!e.defaultPrevented && this._rootRef.current && this._rootRef.current.contains(document.activeElement)) {
        this._toggleTooltip(true);
      }
    });
    (0, _defineProperty2.default)(this, "_getCharCount", () => {
      const {
        value,
        maxLength
      } = this.props;
      return /*#__PURE__*/React.createElement("div", {
        "data-hook": _dataKeys.DATA_HOOKS.CHAR_COUNT,
        className: _TextFieldSt.classes.charCount,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 264,
          columnNumber: 7
        }
      }, /*#__PURE__*/React.createElement("div", {
        dir: "ltr",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 265,
          columnNumber: 9
        }
      }, `${value.length}/${maxLength}`));
    });
    this._inputId = props.id ?? (0, _uniqueId.default)('label-for-id');
    this._errorMessageId = (0, _uniqueId.default)('error-message');
    this._prefixLabelId = (0, _uniqueId.default)('prefix-label');
  }
  render() {
    const {
      errorMessage,
      success,
      successIcon,
      error,
      disabled,
      theme,
      suffix,
      prefix,
      prefixLabel,
      className,
      withClearButton,
      onClear,
      clearButtonAriaLabel,
      clearButtonAriaLabelledby,
      errorTooltipPlacement,
      label,
      maxLength,
      showCharCount,
      value,
      forceLabel,
      inputClassName,
      'aria-describedby': ariaDescribedByProp,
      newErrorMessage,
      inputRef,
      ...restProps
    } = this.props;
    const dataObject = {
      [_dataKeys.THEME]: theme,
      [_dataKeys.SUCCESS]: success,
      [_dataKeys.ERROR]: error,
      [_dataKeys.EMPTY]: !this.props.value
    };
    const Wrapper = newErrorMessage ? _ErrorMessageWrapper.ErrorMessageWrapper : React.Fragment;
    const hasPrefix = prefix ? true : false;
    const hasErrorMessage = !!errorMessage;
    const stStates = {
      error,
      theme,
      success,
      disabled,
      hasPrefix,
      newErrorMessage,
      hasErrorMessage
    };
    const ariaDescribedBy = (0, _a11y.getAriaDescribedBy)([ariaDescribedByProp, errorMessage ? this._errorMessageId : '', prefixLabel ? this._prefixLabelId : '']);
    return /*#__PURE__*/React.createElement(Wrapper, (0, _extends2.default)({}, newErrorMessage && {
      visible: error && !!errorMessage,
      message: errorMessage,
      messageId: this._errorMessageId,
      className: (0, _TextFieldSt.st)(_TextFieldSt.classes.root, stStates, className),
      suffixText: showCharCount && maxLength && this._getCharCount()
    }, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 329,
        columnNumber: 7
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: newErrorMessage ? (0, _TextFieldSt.st)(_TextFieldSt.classes.container) : (0, _TextFieldSt.st)(_TextFieldSt.classes.root, stStates, className),
      ref: this._rootRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 338,
        columnNumber: 9
      }
    }, label ? /*#__PURE__*/React.createElement("label", {
      "data-hook": _dataKeys.DATA_HOOKS.LABEL,
      htmlFor: this._inputId,
      className: _TextFieldSt.classes.label,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 347,
        columnNumber: 13
      }
    }, label) : forceLabel && /*#__PURE__*/React.createElement("div", {
      className: _TextFieldSt.classes.label,
      "aria-hidden": "true",
      "data-hook": _dataKeys.DATA_HOOKS.LABEL_PLACEHOLDER,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 356,
        columnNumber: 15
      }
    }, "\xA0"), /*#__PURE__*/React.createElement(_CoreInput.CoreInput, (0, _extends2.default)({}, dataObject, {
      className: (0, _TextFieldSt.st)(_TextFieldSt.classes.input, {
        theme
      }),
      inputClassName: `${inputClassName || ''} has-custom-focus`,
      id: this._inputId,
      "aria-describedby": ariaDescribedBy,
      value: value,
      maxLength: maxLength,
      ref: this.TextFieldRef,
      suffix: this._getSuffix(),
      prefix: this._getPrefix(),
      error: error,
      "aria-invalid": error
    }, restProps, {
      disabled: disabled,
      onFocus: this._onFocus,
      inputRef: input => {
        this.inputRef = input;
        inputRef == null ? void 0 : inputRef(input);
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 365,
        columnNumber: 11
      }
    })), maxLength && !(newErrorMessage && error && errorMessage) && showCharCount && this._getCharCount()));
  }
}
exports.TextField = TextField;
(0, _defineProperty2.default)(TextField, "displayName", 'TextField');
(0, _defineProperty2.default)(TextField, "defaultProps", {
  success: false,
  successIcon: false,
  error: false,
  withClearButton: false,
  disabled: false,
  theme: _types2.TextFieldTheme.Box,
  errorTooltipPlacement: 'top-end',
  forceLabel: false
});
//# sourceMappingURL=TextField.js.map